<div class="no-scroll patient-ob">

    <div class="wrapper">

        <!-- ========================== header (start) ========================== -->
        <header class="l-header">

            <div class="on-mobile header-logo">
                <img src="../../assets/icons/logo.svg" alt="Artisan Sonics" />
            </div>
            <div class="l-header-panel">
                <h1 class="t-title-main">Clinics Templates</h1>

                <nav class="header-menu">
                    <a routerLink="/patsearch" class="header-menu-link icon-confirm" matTooltip="Exit"></a>
                </nav>

                <nav class="on-mobile header-mobilePanel">
                    <button class="btn-mobileMenu" id="open-headerMenu" data-show=".header-menu"
                        aria-label="open mobile menu"></button>
                    <button class="btn-mobileMenu" id="open-mainNav" data-show=".l-sidebar"
                        aria-label="open mobile sidebar"></button>
                </nav>

            </div>

        </header>
        <!-- ========================== header (end) ========================== -->

        <main class="l-deashboard">

            <!-- GUS-88: tab strip. The canvas tab below is the original screen, untouched. -->
            <div class="builder-tabs">
                <button type="button" class="builder-tab" [class.active]="tab === 'canvas'"
                    (click)="tab = 'canvas'">Canvas Template</button>
                <button type="button" class="builder-tab" [class.active]="tab === 'builder'"
                    (click)="tab = 'builder'">Exam Builder</button>
            </div>

            <div class="clinic-templates" *ngIf="tab === 'canvas'">
                <div class="content-row">
                    <div class="editor-panel">
                        <h3>{{ editingId ? 'Edit template' : 'New template' }}</h3>

                        <label class="field">
                            <span>Title</span>
                            <input type="text" [(ngModel)]="title" placeholder="Template title" />
                        </label>

                        <label class="field">
                            <span>Content</span>
                        </label>
                        <ckeditor [editor]="Editor" [config]="editorConfig" [(ngModel)]="content"></ckeditor>

                        <div class="doctors">
                            <span class="field-label">Doctors who will see this template</span>
                            <div class="doctor-list">
                                <label *ngFor="let d of doctors" class="doctor-item">
                                    <input type="checkbox" class="custom-check -sq" [checked]="isSelected(d.UID)" (change)="toggleDoctor(d.UID)" />
                                    <i class="customInput-display -sq"></i>
                                    <span>{{ d.Name || d.EngName || ('UID ' + d.UID) }}</span>
                                </label>
                                <div *ngIf="!doctors.length" class="empty">No doctors found for this clinic.</div>
                            </div>
                        </div>

                        <div class="actions">
                            <button type="button" class="blue-btn" [disabled]="!title || loading" (click)="save()">
                                {{ editingId ? 'Update' : 'Create' }}
                            </button>
                            <button type="button" class="orange-btn" *ngIf="editingId" (click)="resetForm()" [disabled]="loading">Cancel</button>
                        </div>
                    </div>

                    <div class="list-panel">
                        <h3>Existing templates</h3>
                        <div class="template-list" *ngIf="templates.length">
                            <div class="template-card" *ngFor="let t of templates" [class.editing]="t.ClinicTemplateID === editingId">
                                <div class="template-card-title">{{ t.Title }}</div>
                                <div class="template-card-doctors">
                                    <span *ngFor="let uid of t.assignedUIDs; let last = last">{{ docLabel(uid) }}{{ last ? '' : ', ' }}</span>
                                    <span *ngIf="!t.assignedUIDs?.length" class="empty">No doctors assigned</span>
                                </div>
                                <div class="template-card-actions">
                                    <button type="button" class="blue-btn" (click)="edit(t)" [disabled]="loading">Edit</button>
                                    <button type="button" class="blue-btn" (click)="openAutotextPopup(t)" [disabled]="loading">AutoText</button>
                                    <button type="button" class="orange-btn" (click)="confirmDelete(t)" [disabled]="loading">Delete</button>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="!templates.length" class="empty">No templates yet.</div>
                    </div>
                </div>
            </div>

            <app-clinic-exam-builder *ngIf="tab === 'builder'"></app-clinic-exam-builder>

        </main>

        <!-- ========================== main sidebar (start) ========================== -->

        <aside class="l-sidebar l-flex l-column">

            <img class="off-mobile sidebar-logo" src="assets/icons/logo.svg" alt="Artisan Sonics" />

            <nav class="mainNav l-fg1 scroller">
            </nav>

            <app-docpanel></app-docpanel>

        </aside>

        <!-- ========================== main sidebar (end) ========================== -->

        <app-bottombar></app-bottombar>

    </div><!-- end wrapper -->
</div>

<div *ngIf="showDeleteConfirm" class="t-popup popup-patientDetails popup-centered">
    <div class="t-popup-frame">
        <div class="t-popup-body">

            <button class="t-btn-popup-close" aria-label="close popup" (click)="cancelDelete()"></button>

            <h2 style="color: #D7A95B; text-align: center;">
                Delete template "{{ templateToDelete?.Title }}"?
                <br>
                This cannot be undone.
            </h2>
            <div style="display: flex; justify-content: center;">
                <button class="blue-btn" [disabled]="loading" (click)="doDelete()">Yes</button>
                <button class="orange-btn" style="margin-left: 2em" [disabled]="loading" (click)="cancelDelete()">No</button>
            </div>

        </div>
    </div>
</div>

<app-clinic-autotext-popup
    [display]="!!autotextPopupTemplate"
    [clinicTemplateId]="autotextPopupTemplate?.ClinicTemplateID"
    [clinicTemplateTitle]="autotextPopupTemplate?.Title"
    (close)="closeAutotextPopup()"
></app-clinic-autotext-popup>
